import React from 'react';
import ToolLayout from '../../components/ToolLayout';
import Base64Converter from '../../components/Base64Converter';

const Base64Convert: React.FC = () => (
  <ToolLayout
    title="Base64 Encoder Decoder Online Free | AllTools"
    description="Encode and decode Base64 text and data online. Free Base64 converter tool."
    canonicalPath="/base64-converter"
  >
    <Base64Converter />
  </ToolLayout>
);

export default Base64Convert;
